module.exports = __webpack_public_path__ + "static/media/1C_primary_RGB_KO.76feefa8.png";